module.exports = __webpack_public_path__ + "static/media/raindrops.694c09ab.svg";